/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: "/dashboard/analytics",
    name: "Dashboard",
    slug: "dashboard-analytics",
    // tag: '2',
    // tagColor: 'warning',
    icon: "HomeIcon",
    i18n: "Dashboard",
    rule: "manager"
  },
  {
    header: "Pages",
    icon: "FileIcon",
    i18n: "Pages",
    items: [
      // 공지사항
      {
        url: "/pages/info",
        name: "Info",
        slug: "page-info",
        icon: "BellIcon",
        i18n: "Info",
        rule: "manager"
      },
      // MD 관리
      {
        url: null,
        name: "MD Management",
        icon: "AirplayIcon",
        i18n: "Mdlist",
        submenu: [
          {
            url: "/pages/mdlist/detail",
            name: "Mdlist Detail",
            slug: "page-mdlist-detail",
            i18n: "MD List",
            rule: "manager"
          },
          {
            url: "/pages/mdlist/total",
            name: "Mdlist Total",
            slug: "page-mdlist-total",
            i18n: "Total MD List",
            rule: "admin"
          }
        ]
      },
      // 실적 관리
      {
        url: null,
        name: "Campaign Management",
        icon: "AirplayIcon",
        i18n: "Campaign",
        submenu: [
          {
            url: "/pages/campaign/detail",
            name: "Campaign Detail",
            slug: "page-campaign-detail",
            i18n: "Campaign List",
            rule: "super"
          },
          {
            url: "/pages/campaign/total",
            name: "Campaign Total",
            slug: "page-campaign-total",
            i18n: "Total Campaign List",
            rule: "super"
          }
        ]
      },
      // 공지 관리
      {
        url: null,
        name: "Info Management",
        icon: "AlertCircleIcon",
        i18n: "InfoList",
        submenu: [
          {
            url: "/pages/info/list",
            name: "Info List",
            slug: "page-info-list",
            i18n: "Info List",
            rule: "super"
          }
        ]
      },
      // 사용자 관리
      {
        url: null,
        name: "User Management",
        icon: "UsersIcon",
        i18n: "UserList",
        submenu: [
          {
            url: "/pages/user/list",
            name: "User List",
            slug: "page-user-list",
            i18n: "User List",
            rule: "super"
          }
        ]
      }
      // 로그인 정보
      // {
      //   url: "/pages/profile",
      //   name: "Profile",
      //   slug: "page-profile",
      //   icon: "UserIcon",
      //   i18n: "Profile",
      //   rule: "manager"
      // }
    ]
  }
]

